const modules = import.meta.glob("./*/*.ts", { eager: true })

const NS = [
  "common",
  "nav",
  "catalog",
  "search",
  "entity",
  "admin",
  "account",
  "query",
  "auth",
  "events",
  "deposits",
  "home",
  "workspaces",
  "writer",
  "union",
  "writers",
  "analytics",
] as const
export type I18nNamespace = (typeof NS)[number]

type Messages = Record<string, Record<string, unknown>>

const resources: Record<string, Messages> = {}

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/)
  if (!match) return
  const [, lang, ns] = match
  const module = modules[path] as { default?: Record<string, unknown> }
  if (!module.default) return
  if (!resources[lang]) resources[lang] = {}
  resources[lang][ns] = module.default
})

/** Дублируем неймспейсы в `translation`, чтобы работали ключи вида `nav.catalog`, `common.loading`. */
Object.keys(resources).forEach((lang) => {
  const nested: Record<string, unknown> = {}
  NS.forEach((ns) => {
    if (resources[lang][ns]) nested[ns] = resources[lang][ns]
  })
  resources[lang].translation = nested
})

export const i18nNamespaces = [...NS, "translation"] as const

export default resources
